// JS-readable cookie for client logic; server may mirror version separately via HttpOnly cookie
const NAME = 'cmp.consent.v1';
const oneYear = 60 * 60 * 24 * 365;
function setCookie(name, value, maxAge = oneYear, domain) {
    if (typeof document === 'undefined')
        return; // SSR no-op
    const parts = [
        `${name}=${encodeURIComponent(value)}`,
        'Path=/',
        `Max-Age=${maxAge}`,
        'Secure',
        'SameSite=Lax',
        domain ? `Domain=${domain}` : '',
    ].filter(Boolean);
    document.cookie = parts.join('; ');
}
function getCookie(name) {
    if (typeof document === 'undefined')
        return null; // SSR
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]+)`));
    return m ? decodeURIComponent(m[1]) : null;
}
export class CookieConsentStore {
    domain;
    constructor(domain) {
        this.domain = domain;
    }
    read() {
        try {
            const raw = getCookie(NAME);
            return raw ? JSON.parse(raw) : null;
        }
        catch {
            return null;
        }
    }
    write(state) {
        try {
            setCookie(NAME, JSON.stringify(state), undefined, this.domain);
        }
        catch {
            // ignore
        }
    }
    clear() {
        try {
            setCookie(NAME, '', -1, this.domain);
        }
        catch {
            // ignore
        }
    }
}
//# sourceMappingURL=store.cookie.js.map